import React, { useState, useEffect } from 'react';
import { GAPS_FILTER_COLUMNS } from 'constants/reports';
import { GapFilterData } from 'store/ducks/Reporting/types';
import { useFilterOptions } from 'utils/hooks/useFilterOptions';
import { useSelector } from 'react-redux';
import { RootState } from 'store/configureStore';
import Helpers from 'utils/Helpers';
import ApiService from 'utils/ApiCalls';
import CustomTable from 'components/Tables/CustomTable';
import * as Styled from './GapsFilter.styled';

const GapsFilter: React.FC = () => {
  const { loading } = useFilterOptions();
  const [data, setData] = useState<GapFilterData[]>([]);

  const { orgContext, lang } = useSelector((state: RootState) => ({
    orgContext: state.global.hierarchicalLevelsScope,
    lang: state.global.lang
  }));

  const filterParams = Helpers.toApiFilters(orgContext);
  const normalizedFilters = Helpers.normalizeFilters(
    Helpers.toApiFilters(orgContext)
  );

  const handleDisplay = async () => {
    try {
      if (!orgContext || Object.keys(orgContext).length === 0) return;

      const hasFilters = Object.keys(filterParams).length > 0;
      if (!hasFilters) return;

      const response = await ApiService.getGapsFilter(lang, normalizedFilters);

      const responseData = Array.isArray(response.data)
        ? response.data
        : response.data?.data || [];
      const formattedData = responseData.map(
        (item: GapFilterData, index: number) => ({
          ...item,
          key: item.gap_id || index
        })
      );
      setData(formattedData);
    } catch (error) {
      console.error('Failed to fetch Gaps Filter data:', error);
    }
  };

  useEffect(() => {
    if (!lang) return;
    if (!orgContext || Object.keys(orgContext).length === 0) return;

    handleDisplay();
  }, [lang, orgContext]);

  return (
    <Styled.VerticalSpace direction='vertical' size='large'>
      <CustomTable
        drawTable={true}
        itemsCount={data.length}
        columns={GAPS_FILTER_COLUMNS}
        dataSource={data}
        scroll={{ x: 1600, y: 400 }}
        loading={loading}
        rowKey={(record: GapFilterData) => record.key}
        sticky
      />
    </Styled.VerticalSpace>
  );
};

export default GapsFilter;
